import { FOLD_STATE, ProjectMap } from '../Components/ProjectTypes';
import ProjectComponentWrapper from "../Components/Project";
import { SingleProjectState } from '../SiteState/SiteStateTypes';

function SingleProjectLayout({ projectMap, singleProjectState }: { projectMap: ProjectMap, singleProjectState?: SingleProjectState }) {
    if (!singleProjectState) {
        return null;
    }

    const project = projectMap[singleProjectState.currentProjectKey];

    return (
        <div style={{ width: "100%", height: "100%" }} className="singleProjectLayout">
            <ProjectComponentWrapper foldState={FOLD_STATE.FULL} project={project} />
        </div>
    );
}

export default SingleProjectLayout;